module.exports = __webpack_public_path__ + "img/illustration-link-in-email.5163f1c8.svg";